import { get } from "./request";

export async function getTeam(params) {
  return await get("/team/get_team/", params);
}
